import { useTranslate } from '@im/react-localization';
import { GridOverlay } from '@mui/x-data-grid';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import React from 'react';
import { CenterLoader } from '@im/ui-lib/CenterLoader';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useDateTimeFormatter } from 'src/hooks/dateTimeFormatter';

export function FormatDateToString(params: string) {
  const formatDateTime = useDateTimeFormatter();
  const c = params ? params.toString().substring(0, 10) : '';
  const Mydate = c ? formatDateTime(c) : c;
  return Mydate;
}

export function NoRowsOverlay() {
  const translate = useTranslate();
  return (
    <GridOverlay data-testid="grid_VendorDealsNoRecord">
      <div style={{ color: 'red', textAlign: 'left' }}>
        {translate('Common.NoRecord')}
      </div>
    </GridOverlay>
  );
}

export function NoRowsOverlay_2(marginTop: number, message?: string) {
  const translate = useTranslate();
  return (
    <Stack alignItems="center" mt={marginTop}>
      <Typography sx={{ fontWeight: 400 }} variant="error">
        {message ?? translate('Common.NoRecord')}
      </Typography>
    </Stack>
  );
}

export function SortedDescendingIcon() {
  return <ExpandMoreIcon className="icon" />;
}

export function SortedAscendingIcon() {
  return <ExpandLessIcon className="icon" />;
}

export function LoadingOverlay() {
  return <CenterLoader />;
}
